<!-- 设置单位 -->
<template>
  <div>
    <el-dialog
      width="1000px"
      title="设置单位"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <div class="table-top">
          <div
            v-for="(item, index) in selfData.dan_wei_zu_list"
            :key="index"
            class="table-unit-group"
          >
            <vxe-grid v-bind="tableOptions" :data="item.dan_wei_list">
              <!-- slot_header -->
              <template #header_left>
                <div class="flex flex-y-center">
                  <span class="unit-group-tag">{{ item.dan_wei_zu_name }}</span>
                </div>
              </template>
              <template #header_right>
                <div class="flex flex-y-center flex-x-between">
                  <div class="flex flex-y-center">
                    <span>公式({{ getGroupUnitMainUnitName(index) }})：</span>
                    <span>
                      {{ item.gong_shi_list.length ? item.gong_shi_list.join('') : '无' }}
                    </span>
                  </div>
                  <div></div>
                </div>
              </template>

              <!-- slot_default -->
              <template #default_dan_wei_name="{ row }">
                <el-input size="mini" clearable v-model="row.dan_wei_name" />
              </template>
              <template #default_zhuan_huan_zhi="{ row }">
                <el-input
                  type="number"
                  size="mini"
                  clearable
                  :disabled="row.is_zhu_ji_liang"
                  v-model="row.zhuan_huan_zhi"
                />
              </template>
              <template #default_is_zhu_ji_liang="{ row, rowIndex }">
                <span v-if="row.is_zhu_ji_liang" class="unit-sub-tag">主计量</span>
                <el-link
                  v-if="!row.is_zhu_ji_liang"
                  class="set-default"
                  type="primary"
                  :underline="false"
                  @click="itemUnitSetZhuJiLiang(index, rowIndex)"
                >
                  设为主计量
                </el-link>
              </template>
              <template #default_operate="{ rowIndex }">
                <el-link type="success" @click="itemUnitAdd(index, rowIndex)">增行</el-link>
                <el-link type="danger" @click="itemUnitDelete(index, rowIndex)">删行</el-link>
              </template>
              <template #default_is_mo_ren_dan_wei="{ row, rowIndex }">
                <span v-if="row.is_mo_ren_dan_wei" class="unit-sub-tag">默认单位</span>
                <el-link
                  v-if="!row.is_mo_ren_dan_wei"
                  class="set-default"
                  type="primary"
                  :underline="false"
                  @click="itemUnitSetMoRenDanWei(index, rowIndex)"
                >
                  设为默认单位
                </el-link>
              </template>
              <template #default_verify_unit_val="{ row }">
                <div class="flex flex-y-center flex-x-between">
                  <span class="flex-1 m-r-5">
                    {{ $util.getNumberFullString(row.verify_unit_val) }}
                  </span>
                  <span class="c-gray-light">{{ row.dan_wei_name }}</span>
                </div>
              </template>
            </vxe-grid>
          </div>
        </div>
        <div class="table-bottom">
          <div class="verify-cont">
            <div class="verify-title">校验示例:</div>
            <div class="m-t-10">
              <e-form ref="refVerifyForm" :column="verifyFormColumn" :data.sync="verifyData" />
            </div>
            <el-button type="warning" size="mini" @click="actionVerify">开始校验</el-button>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: [],
      tableOptions: {
        size: 'mini',
        border: true,
        'min-height': 60,
        columns: [
          {
            slots: { header: 'header_left' },
            children: [
              {
                title: '单位',
                width: 160,
                slots: { default: 'default_dan_wei_name' }
              }
            ]
          },
          {
            slots: { header: 'header_right' },
            children: [
              {
                title: '换算率',
                width: 160,
                titleSuffix: {
                  content: '辅计量对比主计量的换算比例',
                  icon: 'vxe-icon-question-circle-fill'
                },
                slots: { default: 'default_zhuan_huan_zhi' }
              },
              {
                title: '主计量单位',
                width: 160,
                slots: { default: 'default_is_zhu_ji_liang' }
              },
              {
                title: '是否默认单位',
                width: 160,
                slots: { default: 'default_is_mo_ren_dan_wei' }
              },
              {
                title: '单位参数校验',
                width: 160,
                slots: { default: 'default_verify_unit_val' }
              },
              {
                title: '操作',
                align: 'right',
                slots: { default: 'default_operate' }
              }
            ]
          }
        ]
      },
      verifyData: {
        mo_ren_dan_wei_zu: ''
      },
      verifyFormColumn: [
        {
          type: 'text',
          field: 'mo_ren_dan_wei_zu',
          title: '默认单位',
          disabled: true,
          width: '155px'
        }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    selfData: {
      handler(val) {
        if (val.dan_wei_zu_list) {
          let result = ''
          val.dan_wei_zu_list.forEach((itemSt) => {
            itemSt.dan_wei_list.forEach((itemNd) => {
              if (itemNd.is_mo_ren_dan_wei) {
                result = `${itemNd.dan_wei_name},${itemSt.dan_wei_zu_name}`
                this.selfData.mo_ren_dan_wei_zu = result
              }
            })
          })
          this.verifyData.mo_ren_dan_wei_zu = this.$tool.getDanWei(result)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.selfShow = this.show
    this.initDanWeiZuList()
  },
  methods: {
    // 初始化单位组列表
    initDanWeiZuList() {
      let selfData = this.$util.deepCopy(this.data)
      if (selfData.dan_wei_zu_list.length) {
        selfData.dan_wei_zu_list.forEach((itemSt) => {
          itemSt.dan_wei_list.forEach((itemNd) => {
            itemNd.verify_unit_val = ''
          })
        })
      } else {
        selfData.dan_wei_zu_list = this.$util.deepCopy(this.$constant.shangPinMuBanUnitListZuZhuang)
      }
      this.selfData = selfData
    },
    // 组-单位-主计量名称
    getGroupUnitMainUnitName(indexSt) {
      let result = ''
      this.selfData.dan_wei_zu_list[indexSt].dan_wei_list.forEach((itemNd) => {
        if (itemNd.is_zhu_ji_liang) result = itemNd.dan_wei_name
      })
      return result
    },
    // 项-单位-新增
    itemUnitAdd(idxSt, idxNd) {
      let result = {
        dan_wei_name: '',
        zhuan_huan_zhi: '',
        is_zhu_ji_liang: false,
        is_mo_ren_dan_wei: false,
        verify_unit_val: ''
      }
      this.selfData.dan_wei_zu_list[idxSt].dan_wei_list.splice(idxNd + 1, 0, result)
    },
    // 项-单位-删除
    itemUnitDelete(idxSt, idxNd) {
      let { is_zhu_ji_liang, is_mo_ren_dan_wei } =
        this.selfData.dan_wei_zu_list[idxSt].dan_wei_list[idxNd]
      if (is_zhu_ji_liang) {
        this.$message.error('主计量单位不能删除')
      } else if (is_mo_ren_dan_wei) {
        this.$message.error('默认单位不能删除')
      } else {
        if (this.selfData.dan_wei_zu_list[idxSt].dan_wei_list.length > 1) {
          this.selfData.dan_wei_zu_list[idxSt].dan_wei_list.splice(idxNd, 1)
        } else {
          this.selfData.dan_wei_zu_list[idxSt].dan_wei_list[idxNd].dan_wei_name = ''
          this.selfData.dan_wei_zu_list[idxSt].dan_wei_list[idxNd].zhuan_huan_zhi = ''
          this.selfData.dan_wei_zu_list[idxSt].dan_wei_list[idxNd].is_zhu_ji_liang = false
        }
      }
    },
    // 项-单位-设置默认单位
    itemUnitSetMoRenDanWei(idxSt, idxNd) {
      let activeObj = this.selfData.dan_wei_zu_list[idxSt].dan_wei_list[idxNd]
      if (!activeObj.dan_wei_name) {
        this.$message.error('设为默认单位，单位名称不能为空')
        return
      }
      if (!Number(activeObj.zhuan_huan_zhi)) {
        this.$message.error('设为默认单位，换算率不能为空或0')
        return
      }

      this.selfData.dan_wei_zu_list.forEach((itemSt, indexSt) => {
        itemSt.dan_wei_list.forEach((itemNd, indexNd) => {
          let result = indexSt === idxSt && indexNd === idxNd
          itemNd.is_mo_ren_dan_wei = result
        })
      })
    },
    // 项-单位-设置主计量
    itemUnitSetZhuJiLiang(idxSt, idxNd) {
      let activeObj = this.selfData.dan_wei_zu_list[idxSt].dan_wei_list[idxNd]
      let oldVal = activeObj.zhuan_huan_zhi
      if (!activeObj.dan_wei_name) {
        this.$message.error('设为主计量，单位名称不能为空')
        return
      }
      if (!Number(activeObj.zhuan_huan_zhi)) {
        this.$message.error('设为主计量，换算率不能为空或0')
        return
      }

      this.selfData.dan_wei_zu_list[idxSt].dan_wei_list.forEach((item, index) => {
        if (index === idxNd) {
          item.is_zhu_ji_liang = true
        } else {
          item.is_zhu_ji_liang = false
        }
        item.zhuan_huan_zhi = this.$XEUtils.divide(item.zhuan_huan_zhi, oldVal)
      })
    },
    // 开始校验
    actionVerify() {
      // 单位组-单位参数校验------------------------------------------
      this.selfData.dan_wei_zu_list.forEach((itemSt) => {
        // 主计量-单位参数校验
        let main_verify_unit_val = '' // 主计量-规格单位
        itemSt.dan_wei_list.forEach((itemNd) => {
          if (itemNd.is_zhu_ji_liang) {
            let result = this.$tool.gongShiResult(itemSt.gong_shi_list, {}) // 使用：公式计算
            itemNd.verify_unit_val = result
            main_verify_unit_val = result
          }
        })
        // 辅计量-单位参数校验
        itemSt.dan_wei_list.forEach((itemNd) => {
          if (!itemNd.is_zhu_ji_liang) {
            itemNd.verify_unit_val = this.$XEUtils.multiply(
              main_verify_unit_val,
              itemNd.zhuan_huan_zhi
            )
          }
        })
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.actionVerify()
      this.$emit('update:data', this.selfData)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .table-top {
    max-height: 542px;
    padding: 5px;
    overflow-y: auto;
    .scroll-bar();
    border: @borderTable;
    .table-unit-group {
      & ~ .table-unit-group {
        margin-top: 5px;
      }
      .unit-group-tag {
        color: @colorWhite;
        padding: 0 2px;
        margin-right: 5px;
        border-radius: 2px;
        background: @colorBlue;
      }
      .unit-sub-tag {
        color: @colorWhite;
        padding: 0 2px;
        margin-right: 5px;
        border-radius: 2px;
        background: @colorGreen;
      }
      .set-default {
        display: none;
      }
      /deep/ .row--hover {
        .set-default {
          display: block;
        }
      }
    }
  }
  .table-bottom {
    display: flex;
    align-items: center;
    padding: 5px;
    margin-top: 5px;
    border: @borderTable;
    .verify-cont {
      display: flex;
      align-items: center;
      height: 28px;
      overflow: hidden;
      .verify-title {
        width: 98px;
        margin-right: 10px;
        text-align: center;
        line-height: 28px;
        font-size: 12px;
        color: @colorOrangeYellow;
        background: @colorOrangeYellow20;
        border-radius: 3px;
      }
      /deep/ .el-button {
        height: 28px;
        line-height: 28px;
        padding: 0 10px;
      }
    }
  }
}
</style>
